// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_UHEoDT","container":"ob_3F5EAg","container__left":"ob_QynLkB","container__right":"ob_iQAQzn","logoIcon":"ob_0Fw7BK","genreList":"ob_CL9KoB"};